import React from 'react';

export default class Breadcrumb extends React.Component {
    render() {
        const { categoryId, categoryName, goBackToPreviousLevel, isActive } = this.props;

        return (
            <span
                className={`breadcrumb-item${isActive ? ' active' : ' cursor-pointer'}`}
                onClick={() => goBackToPreviousLevel(categoryId, categoryName)}
            >
                {categoryName}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/War/Breadcrumb.js